import script from "./EditorTranspose.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorTranspose.vue?vue&type=script&setup=true&lang=js"

import "./EditorTranspose.vue?vue&type=style&index=0&id=09dd1b63&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09dd1b63"]])

export default __exports__